export default __webpack_public_path__ + "static/arrow-1493cf7c0d3367bcb233bec22d98eb47.png";